import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import locandina from "../../images/Evidenza/Manutenzione_2.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import Spa from "../Spa";
import SpaceL from "../../commons/SpaceL";


function CorsoBls () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{"08/02/2025"}</p>
            <TitoloSezioni title={"Corso BLS"} />
            <div className="container-foto-news m-auto d-none d-sm-block " style={{display: "flex", flexDirection: "column", width: "50%"}}>
               <br/>
                <p style={{fontSize: "16px"}}>
                    Il giorno 8/2 dalle 14 alle 19 nell’aula di danza e fitness del
                    <br/><strong>Centro Sportivo Il Cigno</strong>
                    <br/> Effeci Rescue terrà un <strong>corso di BLS</strong>
                    <br/>(con certificazione all’uso del defibrillatore - Certificato nazionale LAICO AREU).
                    <br/>In questo corso verranno insegnate le tecniche di rianimazione e le manovre salvavita su adulto, bambino e lattante.
                    <br/>Il Corso durerà <strong>5 ore</strong> ed è aperto a chiunque voglia imparare ad usare il defribillatore automatico esterno (DAE).
                    <br/>La certificazione e il tesserino AREU ha validità di <strong>24 mesi.</strong>
                    <br/>Non c’è bisogno di nessuna esperienza specifica nel campo del pronto soccorso.
                    <br/>In questo corso verranno date le basi per il primo soccorso cardiaco.
                    <br/>Il costo è di <strong>60 euro</strong>
                </p>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/He5IqUCQ92Y?si=PlomnPkPKA5P907D" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
            <div className="container-foto-news m-auto d-sm-none" style={{display: "flex", flexDirection: "column", width: "80%"}}>
                <p style={{fontSize: "16px"}}>
                    Il giorno 8/2 dalle 14 alle 19 nell’aula di danza e fitness del
                    <br/><strong>Centro Sportivo Il Cigno</strong>
                    <br/> Effeci Rescue terrà un <strong>corso di BLS</strong>
                    <br/>(con certificazione all’uso del defibrillatore - Certificato nazionale LAICO AREU).
                    <br/>In questo corso verranno insegnate le tecniche di rianimazione e le manovre salvavita su adulto, bambino e lattante.
                    <br/>Il Corso durerà <strong>5 ore</strong> ed è aperto a chiunque voglia imparare ad usare il defribillatore automatico esterno (DAE).
                    <br/>La certificazione e il tesserino AREU ha validità di <strong>24 mesi.</strong>
                    <br/>Non c’è bisogno di nessuna esperienza specifica nel campo del pronto soccorso.
                    <br/>In questo corso verranno date le basi per il primo soccorso cardiaco.
                    <br/>Il costo è di <strong>60 euro</strong>
                </p>
                <iframe width="336" height="189" src="https://www.youtube.com/embed/He5IqUCQ92Y?si=PlomnPkPKA5P907D" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>

            <Space />

        </div>
    )
}
export default CorsoBls